import "./NetworkAccess.module.css";
import Header from "@/reusable_sections/Header";
import ConnectWithUs from "./sections/ConnectWithUs";
import LeadershipTeam from "./sections/LeadershipTeam";
import CommonInquiries from "./sections/CommonInquiries";
import Footer from "@/reusable_sections/Footer";
export default function NetworkAccessPage() {
  return <div>
      <Header />
      <ConnectWithUs />
      <LeadershipTeam />
      <CommonInquiries />
      <Footer />
    </div>;
}